import React, { useState } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import ToggleSwitchNo from "../../shared/icons/ToggleSwitchNo";
import ToggleSwitchYes from "../../shared/icons/ToggleSwitchYes";

const CustomSwitch = ({ onToggle, defaultValue }) => {
  const [isChecked, setIsChecked] = useState(defaultValue || false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    onToggle(!isChecked);
  };

  return (
    <div className={style.switch} onClick={handleToggle}>
      {isChecked ? <ToggleSwitchYes /> : <ToggleSwitchNo />}
    </div>
  );
};

export default CustomSwitch;
